// page-invoke.ts — le maillon entre la table de routes et le handler de page.
//
// Une seule ligne de logique, isolée ici pour UNE raison : sa version
// précédente jetait la promesse du handler (`void handler(params)`), et ce
// détail a coûté deux corrections successives du routeur.
//
// Le routeur a besoin de savoir QUAND une page a fini de rendre, pour rattraper
// les navigations concurrentes — une page lente qui aboutit après un clic sur
// un autre menu écrase le contenu de la nouvelle page. En jetant la promesse,
// ce wrapper annonçait chaque page comme terminée avant qu'elle ait chargé quoi
// que ce soit : le rattrapage s'exécutait dans le vide, et le symptôme restait
// entier.
//
// Dans `boot.ts` le bug était invisible à la relecture — le `void` y passait
// pour une intention. Ici, il a un test.

/** Table `pages.<clé>` telle que la peuplent les modules `page-*.ts`. */
export type PagesTable = Record<string, ((params: unknown) => unknown) | undefined>;

/**
 * Appelle le handler de page et **retourne sa promesse**.
 *
 * Une clé inconnue rend `undefined` sans lever : la table est peuplée par des
 * modules chargés dans un ordre que la table de routes ne contrôle pas.
 */
export function invokePage(
  pages: PagesTable,
  pageKey: string,
  params: unknown,
): void | Promise<void> {
  const handler = pages[pageKey];
  if (!handler) return;
  return handler(params) as void | Promise<void>;
}
